import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { GetAdditionalEntityDetailsClientResponse } from '../@types/getAdditionalEntityDetails'

type Store = {
  policyholderAdditionalDetails: GetAdditionalEntityDetailsClientResponse | null
  setPolicyholderAdditionalDetails: (
    value: GetAdditionalEntityDetailsClientResponse,
  ) => void
}

export const useGetAdditionalEntityDetailsStore = create<Store>()(
  devtools(
    (set) => ({
      policyholderAdditionalDetails: null,
      setPolicyholderAdditionalDetails: (policyholderAdditionalDetails) =>
        set({ policyholderAdditionalDetails }),
    }),
    { name: 'GetAdditionalEntityDetailsStore' },
  ),
)
